import NotFoundComponent from "PFComponents/not_found/not_found";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import FeedPage from "./feed_page";
import { useFeedPage } from "./use_feed_page";

const FeedController = () => {
  const { section } = useParams();

  const initPage = {
    tasks: null,
    section,
    fetchActivities: null,
    loaded: false,
    saveInterestedSkill: null,
    postTask: null
  };

  const WrappedFeedPage = usePageWrapper(FeedPage);
  const {
    loaded,
    errors,
    tasks,
    fetchActivities,
    fetchActivitiesDocs,
    tab,
    setTab,
    saveInterestedSkill,
    handleFilterChange,
    handleFiltersReplace,
    handleOrderChange,
    showFilters,
    clearFilters,
    toggleFilters,
    clearRefValue,
    handleEditPost,
    postTask,
    fetchCourses,
    fetchRssFeed,
    filtersAreClear
  } = useFeedPage(initPage);

  const { t } = useTranslation();

  return (
    <WrappedFeedPage
      loading={!loaded}
      errors={errors}
      errorComponent={<NotFoundComponent message={errors ? errors.join(", ") : t("pageNotFound")} />}
      tasks={tasks}
      tab={tab}
      setTab={setTab}
      fetchActivities={fetchActivities}
      fetchActivitiesDocs={fetchActivitiesDocs}
      saveInterestedSkill={saveInterestedSkill}
      showFilters={showFilters}
      toggleFilters={toggleFilters}
      handleFilterChange={handleFilterChange}
      handleFiltersReplace={handleFiltersReplace}
      handleOrderChange={handleOrderChange}
      clearFilters={clearFilters}
      clearRefValue={clearRefValue}
      handleEditPost={handleEditPost}
      postTask={postTask}
      fetchCourses={fetchCourses}
      fetchRssFeed={fetchRssFeed}
      filtersAreClear={filtersAreClear}
    />
  );
};

export default FeedController;
